<ng-container [formGroup]="form">
  <app-form-field [label]="'Address line 1'" formControlName="addressLine1">
    <app-form-text-input [appQmSanitise]="'block'" />
  </app-form-field>

  <app-form-field [label]="'Address line 2'" formControlName="addressLine2">
    <app-form-text-input [appQmSanitise]="'block'" />
  </app-form-field>

  <app-form-field [label]="'Town / City'" formControlName="addressLine3">
    <app-form-text-input [appQmSanitise]="'block'" />
  </app-form-field>

  @if (addressProvinceFormOptions?.length) {
    <app-form-field [label]="'County'" formControlName="addressLine4">
      <app-form-select [fill]="true" [options]="addressProvinceFormOptions" />
    </app-form-field>
  } @else {
    <app-form-field [label]="'County'" formControlName="addressLine4">
      <app-form-text-input [appQmSanitise]="'block'" />
    </app-form-field>
  }

  <app-form-field
    [label]="'ADDRESS_POSTAL_CODE_LABEL' | translate"
    formControlName="postalCode"
  >
    <app-form-text-input [appQmSanitise]="'encrypt'" />
  </app-form-field>
</ng-container>
